import { useLinkPressedCallback } from '@zenbusiness/application-commons-clickstream';
import BasicBreadcrumbs from '@zenbusiness/zui/BasicBreadcrumbs';
import PropTypes from 'prop-types';

function Breadcrumbs({ items, clickstreamProps }) {
  const trackBreadcrumbClick = useLinkPressedCallback({
    ...clickstreamProps,
    elementName: 'breadcrumb_item'
  });

  return (
    <BasicBreadcrumbs
      items={items}
      onClick={trackBreadcrumbClick}
    />
  );
}

Breadcrumbs.propTypes = {
  clickstreamProps: PropTypes.shape({}),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      to: PropTypes.string
    })
  ).isRequired
};

export { Breadcrumbs };
